import { observer } from "mobx-react";
import React from "react";

import { FormSelectField } from "@components-shared/desktop/inputs";
import AccountStatementCustomDate from "@features/account-statement/desktop/filter/components/AccountStatementCustomDate";
import { useAccountStatementStore } from "@state/hooks/account-statement/useAccountStatementStore";
import { PERIODS } from "@services/account-statement/AccountStatementService";
import { removeFromUrlParams } from "@state";

export const AccountStatementPeriodDropdown = observer(
	function AccountStatementPeriodDropdown() {
		const store = useAccountStatementStore();

		function handleChange(event: { target: { value: string } }) {
			if (
				event.target.value === "custom" &&
				!store.showCustomDateSection
			) {
				store.setShowCustomDateSection(true);
			} else if (store.showCustomDateSection) {
				store.setShowCustomDateSection(false);
				removeFromUrlParams(["startDate", "endDate"]);
			}
		}
		return (
			<>
				<FormSelectField
					className="form__group"
					label="ACC_STATEMENT.FILTER.AS_PERIOD"
					name="asPeriod"
					dropdownData={PERIODS}
					onChange={handleChange}
				/>

				<AccountStatementCustomDate
					showCustomDateSection={store.showCustomDateSection}
				/>
			</>
		);
	}
);
